// Todo: need to remove this file
import { getExecEndpoint } from '../../../service/getExecEndpoint';
import { defaultServer } from '~/api/def/servers/defaultServer';

export const documentsEndpoint = {
  server: defaultServer,
  path: 'documents/fund',
  description: 'Get the fund documents',
};

const endpointDocumentsGetExec =
  getExecEndpoint<DocumentsEndpointDef>(documentsEndpoint);
export const endpointDocumentsGET = async (urlExtra: string) =>
  endpointDocumentsGetExec<'GET'>({ method: 'GET', urlExtra });
export interface DocumentsEndpointDef {
  endpoint: typeof documentsEndpoint;
  methods: {
    GET: {
      response: DocumentsResponse;
    };
  };
}

export type DocumentsResponse = {
  documents: Document[];
  // tabSelection: TabSelection;
  agreementTypes: string[];
  //agreementTypes: AgreementType[];
  fundId: string;
};

export type ExtractionStatus =
  | 'pending'
  | 'started'
  | 'success'
  | 'fail'
  | null;

export type AgreementType = {
  id: string;
  name: string;
};

// export type TabSelection = {
//   tab: string;
// };
